import { Buffer } from 'buffer';
import * as Sentry from '@sentry/nextjs';
import { shared } from '../config';
import { digHttp, http } from './http';
import { ANALYSIS_TYPES } from './constants';

const uploadPhoto = photoData =>
  digHttp
    .get('/api/analysis/getSignedUrl')
    .then(({ data: { url, imageId } }) =>
      http
        .put(
          url,
          Buffer.from(
            photoData.replace(/^data:image\/\w+;base64,/, ''),
            'base64',
          ),
          {
            headers: { 'Content-Type': 'image/jpeg' },
          },
        )
        .then(() => imageId),
    )
    .catch(e => {
      Sentry.captureException(e);
      throw e;
    });

const fetchAnalysis = ({ imageId }) =>
  digHttp
    .get('/api/analysis', { params: { imageId } })
    .then(({ data }) => data)
    .catch(e => {
      Sentry.captureException(e);
      throw e;
    });

export const analyzeWeight = ({ imageId, meta: { customer, pet, ...meta } }) =>
  digHttp
    .post('/api/analysis', {
      connectionId: Number(shared.DIG_CONNECTION_ID),
      imageId,
      analysisType: ANALYSIS_TYPES.weight,
      meta: {
        submissionIntent: meta.submissionIntent ?? 'weight_check',
        customerId: customer.id ?? customer.userId,
        petId: pet?.id,
        profileName: pet.name,
        accountName: `${customer.first_name} ${customer.last_name}`,
        accountEmail: customer.email,
      },
    })
    .then(({ data }) => data)
    .catch(e => {
      Sentry.captureException(e);
      throw e;
    });

export const Dig = {
  uploadPhoto,
  fetchAnalysis,
  analyzeWeight,
};
